<div
  class="label"
  [class.prepend-icon-error]="prependIconState === 'error'"
  [class.prepend-icon-warning]="prependIconState === 'warning'">
  @if (label) {
    <label
      class="ppl-label"
      [class.is-required]="hasRequiredClass"
      [class.is-bold]="bold || hasChanges"
      [class.disabled]="disabled">
      <ng-container *ngTemplateOutlet="prependIconPart"></ng-container>
      {{ label }}
    </label>
  }
  @if (labelContent) {
    <label class="ppl-label">
      <ng-container *ngTemplateOutlet="prependIconPart"></ng-container>
      <ng-container *ngTemplateOutlet="labelContent"></ng-container>
    </label>
  }
  @if (description) {
    <ppl-icon
      pplPopover
      [pplPopoverTooltip]="description"
      pplPopoverTooltipDirection="up"
      pplPopoverTooltipPreserveWhitespace="true"
      [pplPopoverTooltipHoverPreserve]="descriptionHoverPreserve"
      class="description"
      width="14px"
      height="14px"
      svgIcon="info-small-blue"></ppl-icon>
  }
  @if (hasChanges) {
    <ppl-icon
      pplPopover
      pplPopoverTooltip="Undo Changes"
      i18n-pplPopoverTooltip="@@UndoChanges"
      pplPopoverTooltipDirection="up"
      class="form-changes"
      width="14px"
      height="14px"
      svgIcon="undo-action-darkblue"
      (click)="$event.stopPropagation(); undoChanges.emit()"></ppl-icon>
  }
  @if (showClearSelection) {
    <ppl-icon
      pplPopover
      pplPopoverTooltip="Clear Selection"
      i18n-pplPopoverTooltip="@@ClearSelection"
      pplPopoverTooltipDirection="up"
      class="form-changes form-reset"
      width="14px"
      height="14px"
      svgIcon="trash_hover"
      (click)="$event.stopPropagation(); clearSelection.emit()"></ppl-icon>
  }
  @if (actionTemplate) {
    <div class="label-action">
      <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
    </div>
  }
</div>
<ng-content></ng-content>

@if (!showErrorsInTooltip && showErrors && hasErrorClass) {
  <ng-container *ngTemplateOutlet="formControlErrorsTemplate"></ng-container>
}
@if (notice || noticeContent) {
  <span class="notice">
    @if (notice) {
      {{ notice }}
    }
    @if (noticeContent && !notice) {
      <ng-template [ngTemplateOutlet]="noticeContent"></ng-template>
    }
  </span>
}
@if (showErrorsTooltip) {
  <div
    #errorsTooltip
    [style.width.px]="0"
    [style.height.px]="0"
    [pplPopover]="errorsTooltipPopover"
    [pplPopoverEvent]="null"
    [pplPopoverAnchorRect]="errorsTooltipPopoverAnchorRect"></div>
}

<ng-template #errorsTooltipPopover>
  <ppl-popover-tooltip type="error">
    <ng-container *ngTemplateOutlet="formControlErrorsTemplate"></ng-container>
  </ppl-popover-tooltip>
</ng-template>

<ng-template #formControlErrorsTemplate>
  <ppl-form-control-errors
    [errors]="control ? control.errors : errors"
    [customErrorMessages]="customErrorMessages"></ppl-form-control-errors>
</ng-template>

<ng-template #prependIconPart>
  @if (prependIcon) {
    <ppl-icon
      class="prepend-icon"
      [svgIcon]="prependIcon"
      width="16px"
      height="16px"
      [useSvg]="!!prependIconFill"
      [svgStrip]="prependIconFill ? { enabled: true } : null"
      [fill]="prependIconFill"
      pplPopover
      [pplPopoverDisabled]="!prependIconTooltip"
      [pplPopoverTooltip]="prependIconTooltip"
      [pplPopoverTooltipType]="prependIconState"
      pplPopoverTooltipDirection="up"></ppl-icon>
  }
</ng-template>
